var _path, _line, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.3208 25.1604C50.3208 11.2202 38.9306 0 25.1604 0C11.3901 0 0.16993 11.2202 -7.24792e-05 25.1604C-7.24792e-05 39.1007 11.2201 50.3209 25.1604 50.3209C39.1006 50.3209 50.3208 38.9307 50.3208 25.1604ZM46.0705 24.9904C46.0705 36.5506 36.7204 45.9008 25.1602 45.9008C13.77 45.9008 4.24981 36.5506 4.24981 24.9904C4.24981 13.4302 13.6 4.08008 25.1602 4.08008C36.7204 4.08008 46.0705 13.4302 46.0705 24.9904Z",
    fill: "#FFB300"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1.5,
    y1: -1.5,
    x2: 18.7399,
    y2: -1.5,
    transform: "matrix(0 1 1 0 26.9672 12.4553)",
    stroke: "#FFB300",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 1.83537,
    transform: "matrix(-1 0 0 1 25.656 36.5875)",
    fill: "#FFB300",
    stroke: "#FFB300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.3a54ce8f995be9857da49140c6775819.svg";
export { ForwardRef as ReactComponent };